import { render, staticRenderFns } from "./BankFlowTransaction.vue?vue&type=template&id=0e02235a&"
import script from "./BankFlowTransaction.vue?vue&type=script&lang=js&"
export * from "./BankFlowTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports